import React from "react";
import { useState } from "react";
import ReactSpeedometer from "react-d3-speedometer";
import { IKImage } from "imagekitio-react";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import BoostJobSection from "./BoostJobSection";

const SpeedometerTwo = ({ jesData }) => {
  const [cutOffValue, setCutOffValue] = useState(65);
  const navigate = useNavigate();
  const currentColor = "#F55F0B";
  const boostColor = "#818CF8";
  const cutOffColor = "#2BBD13";

  const unlockedSegmentArray = [
    0,
    jesData?.previous_score * 10,
    jesData?.current_score * 10,
    cutOffValue * 10,
    cutOffValue * 10.1,
    1000,
  ];
  // co
  function sortUnlockedArray() {
    unlockedSegmentArray.sort((a, b) => a - b);
    return unlockedSegmentArray;
  }

  function textData(currentValue) {
    if (currentValue > 75) {
      return "Brilliant!";
    } else if (currentValue > 70) {
      return "Almost There";
    } else if (currentValue > 60) {
      return "your'e on Track";
    } else if (currentValue > 50) {
      return "Don't Stop Now";
    } else if (currentValue > 40) {
      return "Gear up Now!";
    } else if (currentValue > 30) {
      return "Need to push Harder";
    } else if (currentValue > 20) {
      return "Lot Of Room For Improvement";
    } else {
      return "Need Urgent Attention!";
    }
  }

  function emojiLink(currentValue) {
    if (currentValue > 75) {
      return "https://assets.learntube.ai/files/Profile-section/Emoji-7.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1667552831859";
    } else if (currentValue > 70) {
      return "https://assets.learntube.ai/files/Profile-section/Emoji-6.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1667552831885";
    } else if (currentValue > 60) {
      return "https://assets.learntube.ai/files/Profile-section/Emoji-5.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1667552831874";
    } else if (currentValue > 50) {
      return "https://assets.learntube.ai/files/Profile-section/Emoji-4.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1667552831871";
    } else if (currentValue > 40) {
      return "https://assets.learntube.ai/files/Profile-section/Emoji.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1667552831920";
    } else if (currentValue > 30) {
      return "https://assets.learntube.ai/files/Profile-section/Emoji.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1667552831920";
    } else if (currentValue > 20) {
      return "https://assets.learntube.ai/files/Profile-section/Emoji-1.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1667552831886";
    } else {
      return "https://assets.learntube.ai/files/Profile-section/emoji1.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1667560254697";
    }
  }
  return (
    <div className="relative flex w-full flex-col items-center justify-center">
      <ReactSpeedometer
        ringWidth={20}
        width={window.innerWidth < 500 ? 350 : 500}
        customSegmentStops={sortUnlockedArray()}
        forceRender={true}
        needleColor="transparent"
        segmentColors={
          jesData?.current_score < cutOffValue
            ? [currentColor, boostColor, "#F0F0F0", cutOffColor, "#F0F0F0"]
            : jesData?.previous_score > cutOffValue
            ? [currentColor, cutOffColor, "#F55F0B", boostColor, "#F0F0F0"]
            : [currentColor, boostColor, cutOffColor, boostColor, "#F0F0F0"]
        }
        customSegmentLabels={
          jesData?.current_score < cutOffValue
            ? [
                {
                  text: `${jesData?.previous_score}%`,
                  position: "INSIDE",
                  color: "#000000",
                },
                {
                  text: `${jesData?.current_score}%`,
                  position: "OUTSIDE",
                  color: boostColor,
                },
                {
                  text: "",
                  position: "OUTSIDE",
                  color: "#000000",
                },
                {
                  text: `${cutOffValue}%`,
                  position: "OUTSIDE",
                  color: cutOffColor,
                },
                {
                  text: "",
                  position: "OUTSIDE",
                  color: "#000000",
                },
              ]
            : jesData?.previous_score > cutOffValue
            ? [
                {
                  text: `${jesData?.previous_score}%`,
                  position: "INSIDE",
                  color: "#000000",
                },
                {
                  text: `${cutOffValue}%`,
                  position: "OUTSIDE",
                  color: cutOffColor,
                },

                {
                  text: "",
                  position: "OUTSIDE",
                  color: "#000000",
                },
                {
                  text: `${jesData?.current_score}%`,
                  position: "OUTSIDE",
                  color: boostColor,
                },
                {
                  text: "",
                  position: "OUTSIDE",
                  color: "#000000",
                },
              ]
            : [
                {
                  text: `${jesData?.previous_score}%`,
                  position: "INSIDE",
                  color: "#000000",
                },
                {
                  text: "",
                  position: "OUTSIDE",
                  color: "#000000",
                },
                {
                  text: `${cutOffValue}%`,
                  position: "OUTSIDE",
                  color: cutOffColor,
                },
                {
                  text: `${jesData?.current_score}%`,
                  position: "OUTSIDE",
                  color: boostColor,
                },
                {
                  text: "",
                  position: "OUTSIDE",
                  color: "#000000",
                },
              ]
        }
        currentValueText=""
      />
      <div className="absolute top-[4rem] flex flex-col text-center md:top-[6rem] ">
        <h1 className="text-4xl font-bold md:text-5xl">
          {jesData?.current_score}%
        </h1>
        <div className="flex items-center justify-center">
          <img
            urlEndpoint="https://assets.learntube.ai/files/"
            src={emojiLink(jesData?.current_score)}
            transformation={[
              {
                height: "110",
                width: "110",
              },
            ]}
            className="mr-2 h-4"
          />
          <p className="my-2 text-xs">{textData(jesData?.current_score)}</p>
        </div>
        <div className="flex items-center  justify-center self-start text-sm">
          <span className="mr-2 h-4 w-4 rounded bg-[#2BBD13]"></span>
          <p className="text-xs">65%: Cut Off For Job</p>
        </div>
        <div className="mt-1 flex items-center justify-center self-start text-sm">
          <span className="mr-2 h-4 w-4 rounded bg-[#818CF8]"></span>
          <p className="text-xs">Current Score</p>
        </div>
        <div className="mt-1 flex items-center justify-center self-start text-sm">
          <span className="mr-2 h-4 w-4 rounded bg-[#F55F0B]"></span>
          <p className="text-xs">Previous Score</p>
        </div>
        {/* <span className='text-xs text-[#086788] font-semibold border-2 p-2 border-[#086788] flex rounded-full w-[1rem] h-[1rem] justify-center items-center'>i</span> */}
      </div>
      <div className="text-md -mt-20 text-center md:-mt-10 md:text-lg">
        Your job score increased by{" "}
        <span className={`text-[${cutOffColor}]`}>
          {jesData?.score_for_completion}%
        </span>{" "}
        by completing this Micro-Skill
      </div>
      <div className="mt-2 text-lg font-medium">or</div>
      <BoostJobSection jesData={jesData}/>
    </div>
  );
};

export default SpeedometerTwo;
